export const selectJobsState = (state) => state.jobs;

export const selectJobs = (state) => state.jobs.jobs;
export const selectJob = (state) => state.jobs.job;
export const selectJobsCount = (state) => state.jobs.jobsCount;

export const selectJobsOrderBy = (state) => state.jobs.jobsOrderBy;
export const selectJobsFilter = (state) => state.jobs.jobsFilter;
export const selectJobsPagination = (state) => state.jobs.jobsPagination;
